
























































import { computed, defineComponent, ref, set } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import BaseSwitch from "@/components/BaseSwitch";
import CreateRewardModal from "@/components/FundraisingGoal/CreateRewardModal";
import DeleteRewardConfirm from "@/components/FundraisingGoal/DeleteRewardConfirm";
import FundraisingGoalRewardCard from "@/components/FundraisingGoal/FundraisingGoalRewardCard";
import { InputRewardCreate } from "@/components/FundraisingGoal/types";
import ModalView from "@/components/ModalView";
import { InputGoalData } from "@/views/PageFundraisingGoals/PageFundraisingGoals.vue";

export default defineComponent({
  name: "CreateGoalModal",
  components: {
    FundraisingGoalRewardCard,
    DeleteRewardConfirm,
    CreateRewardModal,
    BaseSwitch,
    BaseButton,
    BaseForm,
    ModalView,
  },
  props: {
    userId: { type: String, required: true },
    loading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const valid = ref(false);
    const values = ref<FormValues>({
      dateTime: "",
      amount: "",
      title: "",
      finishWhenReachGoal: false,
    });
    const countOnlyDonations = ref(true);
    const rewards = ref<InputRewardCreate[]>([]);
    const rewardToEditIndex = ref<number | null>(null);
    const rewardToDeleteIndex = ref<number | null>(null);
    const showCreateReward = ref(false);

    const fields = computed<FormFields>(() => [
      {
        name: "title",
        label: $t("Title"),
        type: "text",
        rules: ["required"],
        validationMode: "aggressive",
      },
      {
        name: "amount",
        label: $t("Amount"),
        type: "money",
        rules: ["required"],
        validationMode: "aggressive",
      },
      {
        name: "dateTime",
        label: $t("Cut-off date"),
        type: "dateTime",
        rules: ["required", "no_past_date"],
        validationMode: "aggressive",
      },
      {
        name: "finishWhenReachGoal",
        label: $t("Finish when goal is reached"),
        type: "checkbox",
      },
    ]);

    const rewardToEdit = computed(() =>
      rewardToEditIndex.value !== null ? rewards.value[rewardToEditIndex.value] : null
    );
    const showCreateRewardModal = computed(() => showCreateReward.value || !!rewardToEdit.value);
    const showDeleteRewardConfirm = computed(() => rewardToDeleteIndex.value !== null);

    const onRewardCreateClose = () => {
      showCreateReward.value = false;
      rewardToEditIndex.value = null;
    };

    const onRewardSubmit = (data: InputRewardCreate) => {
      if (rewardToEditIndex.value !== null) rewards.value.splice(rewardToEditIndex.value, 1, data);
      else rewards.value.push(data);
      showCreateReward.value = false;
      rewardToEditIndex.value = null;
    };

    const onRewardDelete = () => {
      if (rewardToDeleteIndex.value === null) return;
      rewards.value.splice(rewardToDeleteIndex.value, 1);
      rewardToDeleteIndex.value = null;
    };

    const inputFinishCheckbox = (v: boolean) => {
      set(values.value, "finishWhenReachGoal", v);
    };

    const onSubmit = async () => {
      if (!valid.value || !values.value.dateTime) return;
      const data: InputGoalData = {
        goal: {
          userId: props.userId,
          title: values.value.title,
          goalAmount: +values.value.amount,
          dueTime: new Date(values.value.dateTime).toISOString(),
        },
        rewards: rewards.value,
      };
      emit("create", data);
    };

    return {
      valid,
      values,
      fields,
      countOnlyDonations,
      showCreateRewardModal,
      showDeleteRewardConfirm,
      rewards,
      rewardToEdit,
      config,
      showCreateReward,
      rewardToEditIndex,
      rewardToDeleteIndex,
      onRewardCreateClose,
      inputFinishCheckbox,
      onSubmit,
      onRewardSubmit,
      onRewardDelete,
    };
  },
});
